module.exports = __webpack_public_path__ + "img/logo.4bd47cc1.png";